export const JOB_SEARCH_FILTERS = [
  "tag",
  "name",
  "company",
  "bike",
  "phone",
  "jobNumber",
] as const

export type JobSearchFilter = (typeof JOB_SEARCH_FILTERS)[number]

const JOB_SEARCH_FILTER_SET: ReadonlySet<string> = new Set(JOB_SEARCH_FILTERS)

export function isJobSearchFilter(value: string): value is JobSearchFilter {
  return JOB_SEARCH_FILTER_SET.has(value)
}
